// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Xt-z","tooltipWrapper":"Yt-z","icon":"Zt-z","tooltip":"_t-z","content":"au-z"};